import React from "react";
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import Access from "../../Utils/authorize";
import {  getAvailable} from "../../Utils/links"
import { GetSystemSettings  } from '../../REST/utilities';
import { ContactUs,RequestLostCard ,WrapperBox} from "./widgets";
import PhoneIcon from '@mui/icons-material/Phone';
import CreditCardOffIcon from '@mui/icons-material/CreditCardOff';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import PageShell from '../../themes/components/PageShell';
import PageHeader from '../../themes/components/PageHeader';
import PageContent from '../../themes/components/PageContent';

const landingLinks = [
    {
        title: 'Contact Us',
        icon: <PhoneIcon   />,
        widget:ContactUs
    },
    {
        title: 'Lost Cards',
        icon: <CreditCardOffIcon   />,
        widget:RequestLostCard
    },
    {
        title : "Add Workorder",
        icon : <HomeRepairServiceIcon />,
        widget : <></>
    }
]


export default function Home() {
    const [config,setConfig] =React.useState(null)
    React.useEffect(()=>{
        GetSystemSettings().then((result)=>{
            const setting = result.data.find((x)=>{ return x.name == "appconfig"} )
            if(setting) setConfig(setting.jsonvalue)

        })
    },[])
    if(config == null ) return <></>
     
    return (
        <Template extralinks={config.landinglinks} list={getAvailable().filter((e, idx) => idx !== 0)} />
    )
}



function Template({ list = [], title, invert = false,extralinks  = true }) {
    const navigate = useNavigate()
    
    const handleLink = (link, external) => {
        if (external)
            window.location.href = link
        else
            navigate(link)
    }

    return <PageShell>
        <PageHeader title={title || 'Dashboard'} />
        <PageContent
            sx={{
                px: { xs: 1.5, sm: 2, md: 3 },
                py: { xs: 2, md: 3 },
            }}
        >
        <Grid container spacing={3}>
            {list.filter(x => {
                if (x.external)
                    return !Access.isInternal()
                return x.secure === true ? Access.isInternal() : true
            }).map((e, i) => {
                return <Grid item xs={12} sm={6} md={3} key={i}>
                    <Card variant="dashboard" onClick={() => handleLink(e.link, e.outside)}>
                        <CardContent>
                            <Box className="dashboard-icon">
                                {e.icon}
                            </Box>
                            <Typography className="dashboard-title" title={e.text} noWrap>
                                {e.text}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            })}
            {
                !extralinks && landingLinks.map((e,i)=>(
                    
                <Grid item xs={12} sm={6} md={3} key={i}>
                    <WrapperBox Widget={e.widget} >
                        <Card variant="dashboard">
                            <CardContent>
                                <Box className="dashboard-icon">
                                    {e.icon}
                                </Box>
                                <Typography className="dashboard-title" title={e.title} noWrap>
                                    {e.title}
                                </Typography>
                            </CardContent>
                        </Card>
                    </WrapperBox>
                </Grid>
            ))}
        </Grid>
        </PageContent>
    </PageShell>
}
